/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/style-prop-object */
import React, { useContext, useEffect, useState } from "react";
import Popup from "../Helpers/Popup/Popup";
import { Modal } from "react-bootstrap";
import PopupTitle from "../Helpers/Popup/PopupParts/PopupTitle";
import Close from "../Helpers/CloseBtn/Close";
import { popupcontext } from "../../context/Popupscontext";
import PopupBodyItem from "../Helpers/Popup/PopupParts/PopupBodyItem";
import axios from "axios";
import { formatDate } from "../../JsHelpers/DateFormat";
import { MapContainer, Marker, TileLayer } from "react-leaflet";
import { Icon } from "leaflet";
import { SpeedUnit } from "../../JsHelpers/PlatformUnits";
import { useSelector } from "react-redux";

export default function NotificationPopup({ positionId, vehicleData }) {
	const { displayAlert, setDisplayAlert } = useContext(popupcontext);
	const [geoCodes, setGeoCodes] = useState({});

	const close = () => {
		setDisplayAlert(null);
	};

	const fetchGeoCodePosition = async () => {
		try {
			const response = await axios.get(
				`https://nominatim.openstreetmap.org/reverse.php?lat=${
					vehicleData?.lat && vehicleData?.lat
				}&lon=${vehicleData?.lon && vehicleData?.lon}&zoom=18&format=jsonv2`,
			);
			setGeoCodes((prev) => ({
				...prev,
				[vehicleData?.id]: response.data.display_name,
			}));
		} catch (error) {
			console.error("Error fetching geocode position:", error);
		}
	};
	useEffect(() => {
		if (
			vehicleData?.lat !== null &&
			vehicleData?.lon !== null &&
			!isNaN(vehicleData?.lat) &&
			!isNaN(vehicleData?.lon)
		) {
			fetchGeoCodePosition();
		}
	}, [vehicleData]);

	const truncateItem = (text) => {
		const maxLength = 50;
		return text?.length > maxLength
			? text.substring(0, maxLength) + "..."
			: text;
	};

	const customIcon = new Icon({
		iconUrl: "https://www.svgrepo.com/show/513317/location-pin.svg",
		iconSize: [32, 32],
		iconAnchor: [16, 32],
		popupAnchor: [0, -32],
	});
	const { formattedDate, formattedTime } = formatDate(vehicleData?.time);
	const inf = useSelector((state) => state.users.user);

	return (
		<Popup show={displayAlert}>
			<Modal.Header className="modal-header flex-between">
				<Modal.Title id="contained-modal-title-vcenter">
					<PopupTitle headtitle="Notification" />
				</Modal.Title>
				<Close style="close-32 close" close={close} img="Close" />
			</Modal.Header>
			<Modal.Body className="modal-body-scrollable">
				<div className="display-border">
					<div>
						<PopupBodyItem
							title="Vehicle Name"
							item={vehicleData?.name || "Loading name..."}
						/>
						{/**<PopupBodyItem
									title="Driver Name"
									item={driverNames || "Loading name..."}
								/>**/}
						<PopupBodyItem
							title="Speed"
							item={SpeedUnit(
								vehicleData?.speed,
								inf?.attributes?.speedUnit || "kn",
							)}
						/>
						<PopupBodyItem
							title="Date"
							item={formattedDate + " " + formattedTime}
						/>
						<PopupBodyItem
							title="Location"
							item={
								truncateItem(geoCodes[vehicleData?.id]) || "Loading address..."
							}
							subitem={geoCodes[vehicleData?.id]}
						/>
						<MapContainer
							center={
								vehicleData
									? [vehicleData.lat, vehicleData.lon]
									: [23.8859, 45.0792]
							} // Update center when position changes
							zoom={33}
							style={{
								marginBlock: "15px",
								height: "250px",
								width: "100%",
								borderRadius: "8px",
							}}
						>
							<TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
							{vehicleData?.lat && vehicleData?.lon && (
								<Marker
									position={[vehicleData?.lat, vehicleData?.lon]}
									icon={customIcon}
								/>
							)}
						</MapContainer>
					</div>
				</div>
			</Modal.Body>
		</Popup>
	);
}
